<template>

  <tr>
    <th scope="row">
      <a :href="value.secure_url" target="_blank">#{{ value.iugu_invoice_id }}</a>
    </th>
    <td>
      <span v-if="value.due_date">{{ $d(new Date(value.due_date), 'short') }}</span>
    </td>
    <td>
      {{ value.total_text }}
    </td>
    <td>
      <InvoiceStatus :value="value.status" />
      <span
        v-if="value.paid_at"
        class="text-muted">em {{ $d(new Date(value.paid_at), 'short') }}</span>
    </td>
  </tr>

</template>

<script>
import InvoiceStatus from '@/components/Parts/InvoiceStatus'

export default {
  name: 'BillingInvoicesItem',
  components: {
    InvoiceStatus
  },
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Billing/BillingInvoicesItem.vue